import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { Parameter } from '../../../../common/params/interfaces/parameter.interface';
import { Command } from '../../../../common/params/interfaces/command.interface';
import { DeviceEvent } from './../../../../common/interfaces/event.interface';
import { BaseRoutingComponent } from '../../../../common/base-routing/base-routing.component';
import { SharedProgrammingService, CommonProgrammingContext, sharedReducer } from '../../../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Util } from '../../../../common/services/utils.service';
import { QSNotificationsService, NotificationProgrammingContext } from '../../services/notifications.service';
import { Param } from '../../../../common/interfaces/event.interface';

@Component({
  selector: 'prg-notification-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.less']
})
export class QSNotificationsParametersComponent extends BaseRoutingComponent {

  private _command: Observable<Command>;
  private _params: Observable<Parameter[]>;
  private _routeParams: Observable<{ command: string, id: string }>;

  private _snapshot = Util.snapshot;

  private _ready: Observable<boolean>;

  private _notificationType: Observable<'push' | 'email'>;

  constructor(
    private _notifications: QSNotificationsService,
    protected store: Store<{
      notificationsProgramming: NotificationProgrammingContext,
      sharedProgramming: CommonProgrammingContext
    }>,
    private _route: ActivatedRoute,
    public router: Router
  ) {
    super();
    this._routeParams = <Observable<{ command: string, id: string }>>this._route.params;

    this._notificationType = this._routeParams
      .map(p => (p.command == 'SEND_EMAIL') ? 'email' : 'push');

    this._command = Observable.combineLatest(
      this._routeParams,
      this.store.select(s => s.notificationsProgramming.commands).filter(c => !!c),
      (routeParams, commands) => {
        let id = parseInt(routeParams.id);
        return commands.find(c => c.command === routeParams.command && c.id === id);
      }
    )
      .filter(c => !!c)
      .map(command => {
        command.display = command.display.replace('Email Notification to', 'Send an email to');
        command.display = command.display.replace('with subject as:', 'with subject');
        return command;
      });

    this._ready = this.store.select(s => s.sharedProgramming.ready);
    this._params = this._command.map(c => (!!c) ? c.params : [])
      .map(params => params
        .map(param => {
          if (param.name == "ADD_TIMESTAMP") {
            param.default = 1;
          }

          if (param.name == 'to') {
            param.placeholder = 'Email address...'
          }

          param._value = param._value || param.value || param[param.valueField] || param.default;
          return param;
        })
      );
  }

  private _setCommand = () => {
    this._notifications.setActionCommand(Util.snapshot<Command>(this._command), Util.snapshot<Parameter[]>(this._params));
  }

  private _identity = (param: Parameter): string => param.name + param.type;
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/action/parameters/parameters.component.ts